import urls from "../global/constants/UrlConstants";
import { getCallParams, getHeaderObject, makeCall } from "../utils/service";
import { store } from "../utils/store";

const base = urls.url_prod;

export async function downloadBulkStageSample() {
  const callParams = await getCallParams("GET");
  const res = await fetch(`${base}/bulk-stage-jobs/sample.xlsx`, callParams as any);
  if (!res.ok) throw new Error("Failed to download sample");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "sample-bulk-lead-stage.xlsx";
  a.click();
  URL.revokeObjectURL(url);
}

export async function createBulkStageJob(formData: FormData) {
  const accessToken = store.getState().auth.accessToken;
  const headers: any = await getHeaderObject(accessToken, {});
  delete headers["Content-Type"];
  const res = await fetch(`${base}/bulk-stage-jobs`, {
    method: "POST",
    headers,
    body: formData,
  });
  const json = await res.json();
  if (!res.ok || json.success === 0) {
    throw new Error(json.message || json.error_msg || "Upload failed");
  }
  return json;
}

export async function getBulkStageJobProgress(id: string) {
  const callParams = await getCallParams("GET");
  return makeCall(`${base}/bulk-stage-jobs/${id}/progress`, callParams);
}

export async function downloadBulkStageFailedReport(id: string) {
  const callParams = await getCallParams("GET");
  const res = await fetch(
    `${base}/bulk-stage-jobs/${id}/failed.xlsx`,
    callParams as any
  );
  if (!res.ok) throw new Error("No failed report");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `failed-bulk-stage-${id}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}
